module.exports = __webpack_public_path__ + "static/courses-67e282674c4285e7dba258e5361e9d0a.jpeg";